export default __webpack_public_path__ + "static/custom-img-1-75bd086260fd3e02acfe0f3859f98123.webp";